import { render } from "./SelectAddressCategoryModal.vue?vue&type=template&id=632d39f2&scoped=true"
import script from "./SelectAddressCategoryModal.vue?vue&type=script&lang=js"
export * from "./SelectAddressCategoryModal.vue?vue&type=script&lang=js"

import "./SelectAddressCategoryModal.vue?vue&type=style&index=0&id=632d39f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632d39f2"]])

export default __exports__